export default "__VITE_ASSET__RLEK69n___"